import { BaseApi, Methods } from "@newview/infrastructure";

export abstract class DbCenterBaseApi extends BaseApi {
    public get ProxyName(): any {
        return 'DbCenterApi';
    }

    /**
     * 分页获取数据
     * @param params 
     * @returns 
     */
    public getEntitiesPage(current: number, size: number = 15, devProd: string = 'dev') {
        return this.send({ current, size, devProd }, "getEntitiesPage", Methods.GET)
    }
}